import T from 'prop-types';
import React, { Component } from 'react';
import request from 'superagent';
import { TextInput } from '@acast/decibel';
import Field from '../../../../../../shared/components/field';
import { DEFAULT_THUMBNAIL } from '../../../../../../shared/helpers/markers';
import { getYoutubeVideoId } from '../../../../../../shared/helpers/video-url';

function tryToFindThumbnailForVideoYoutube(videoUrl) {
  const videoId = getYoutubeVideoId(videoUrl);

  if (videoId) {
    return `https://img.youtube.com/vi/${videoId}/0.jpg`;
  }

  return null;
}

function tryToFindThumbnailForVideoVimeo(videoUrl) {
  const vimeoMatch = videoUrl.match(/vimeo\.com\/(\d+)/);

  if (vimeoMatch) {
    const videoId = vimeoMatch[1];
    return new Promise((resolve, reject) => {
      request.get(`http://vimeo.com/api/v2/video/${videoId}.json`).end((error, response) => {
        if (error) {
          return reject(error);
        }
        return resolve(response.body[0].thumbnail_medium);
      });
    });
  }

  return Promise.reject();
}

function tryToFindThumbnailForVideo(videoUrl) {
  const youtubeThumbnail = tryToFindThumbnailForVideoYoutube(videoUrl);
  if (youtubeThumbnail) {
    return Promise.resolve(youtubeThumbnail);
  }

  return tryToFindThumbnailForVideoVimeo(videoUrl);
}

class VideoUrlField extends Component {
  constructor() {
    super();
    this.state = { extractedThumbnail: null };
  }

  onChange = ({ target: { value } }) => {
    this.props.onChangeUrl(value);

    tryToFindThumbnailForVideo(value)
      .then(this.setExtractedThumbnail)
      .catch(this.clearExtractedThumbnail);
  };

  setExtractedThumbnail = extractedThumbnail => {
    this.setState({ extractedThumbnail });

    if (!this.isMarkerThumbnailSet()) {
      this.setMarkerThumbnailToExtracted();
    }
  };

  setMarkerThumbnailToExtracted = () => {
    this.props.onChangeThumbnail(this.state.extractedThumbnail);
  };

  clearExtractedThumbnail = () => {
    this.setState({ extractedThumbnail: null });
  };

  createClickHereToUpdateThumbnail = () => {
    const { extractedThumbnail } = this.state;
    const { thumbnail } = this.props;

    if (!extractedThumbnail || extractedThumbnail === thumbnail) {
      return null;
    }

    return (
      <span className="update-video-thumbnail" onClick={this.setMarkerThumbnailToExtracted}>
        Click here to grab the thumbnail from that video.
      </span>
    );
  };

  isDifferentThumbnailExtracted = () =>
    this.state.extractedThumbnail && this.state.extractedThumbnail !== this.props.thumbnail;

  isMarkerThumbnailSet = () => {
    return this.props.thumbnail && this.props.thumbnail !== DEFAULT_THUMBNAIL;
  };

  render() {
    const { error, link } = this.props;

    return (
      <Field
        label="Video URL"
        name="video-url"
        subtitle={this.createClickHereToUpdateThumbnail()}
        meta={{ error, touched: true }}
      >
        <TextInput value={link || ''} onChange={this.onChange} />
      </Field>
    );
  }
}

VideoUrlField.propTypes = {
  error: T.string,
  onChangeUrl: T.func.isRequired,
  onChangeThumbnail: T.func.isRequired,
  link: T.string,
  thumbnail: T.string,
};

VideoUrlField.defaultProps = {
  error: undefined,
  link: '',
  thumbnail: undefined,
};

export default VideoUrlField;
